import { PluginDefinition } from 'yam-types'
import { helmOperator, helmUninstaller } from './handlers/helm'
import { name, version } from './package.json'
import * as schema from './schema.json'
import * as settings from './settings.json'
import { HelmReleaseConfig } from './types.d'

export default {
  name,
  schema,
  settings,
  version,
  handlers: {
    'prepare[?(@.type=="helm")]': {
      install: helmOperator,
      uninstall: helmUninstaller
    }
  }
} as PluginDefinition<HelmReleaseConfig>